// src/pages/AdminUsersPage.js
import React, { useState } from "react";
import TopNavTabs from "../components/TopNavTabs";
import AdminTabUsers from "../components/AdminTabUsers";
import AdminTabPicArea from "../components/AdminTabPICArea";
import AdminTabPICAgeGroup from "../components/AdminTabPICAgeGroup";
import AdminTabRoles from "../components/AdminTabRoles";

const tabs = [
  { key: "users", label: "Users", path: "/admin/users" },
  { key: "pic-area", label: "PIC Area", path: "/admin/pic-area" },
  { key: "pic-agegroup", label: "PIC Age Group", path: "/admin/pic-agegroup" },
  { key: "roles", label: "Roles", path: "/admin/roles" },
];

export default function AdminUsersPage() {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div style={{ padding: "1rem", fontSize: "1rem" }}>
      <TopNavTabs items={tabs} activeKey={activeTab} onTabClick={(k) => setActiveTab(k)} />
      <div style={{ marginTop: "1rem" }}>
        {activeTab === "users" && <AdminTabUsers />}
        {activeTab === "pic-area" && <AdminTabPicArea />}
        {activeTab === "pic-agegroup" && <AdminTabPICAgeGroup />}
        {activeTab === "roles" && <AdminTabRoles />}
      </div>
    </div>
  );
}
